import { VOICES } from "../utils"

export default function Voice ({ voice }) {
  const voiceLabel = (VOICES.find(v => v[0] === voice) || [])[0] || (VOICES.find(v => v[1] === voice) || [])[0] || 'older voice'
  return (
    <span className='voice'>{voiceLabel}</span>
  )
}